import { FaCheck } from "react-icons/fa";
import { MdBlock } from "react-icons/md";

const getWatchdogColumns = (t) => {
  const simWatchdogColumns = [
    {
      Header: "Watchdog ID",
      accessor: "watchDog.id",
    },
    {
      Header: t("simProfile.type"),
      accessor: "watchDog.actionType",
    },
    {
      Header: t("simProfile.blockSuspension"),
      accessor: "blockSuspension",
      Cell: ({ row: { original } }) => (
        <>
          {original.blockSuspension && <MdBlock size={18} />}
          {!original.blockSuspension && <FaCheck size={18} />}
        </>
      ),
    },
    {
      Header: t("simProfile.amount"),
      accessor: "amount",
      Cell: ({ row: { original } }) => (
        <>
          {original.watchDog.unitType === "Bytes"
            ? original.watchDog.amount
            : original.watchDog.unitType === "KB"
            ? original.watchDog.amount / 1000.0
            : original.watchDog.unitType === "MB"
            ? original.watchDog.amount / 1000000.0
            : original.watchDog.amount / 1000000000.0}
          {original.watchDog.unitType}/{original.watchDog.service}
        </>
      ),
    },
  ];

  return { simWatchdogColumns };
};

export default getWatchdogColumns;
